import { Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';
import { STREAM_SCREEN_CONFIG } from '../../../../config';
import { HatchedStrip } from './elements';

const TRACK_HEIGHT = STREAM_SCREEN_CONFIG.focusTracksHeight;

/**
 * Empty state for the Live Topics track: full-height strip with hatched pattern
 * and a tooltip explaining that no topics were detected for the range.
 */
export function LiveTopicsEmptyStrip() {
  const { formatMessage } = useIntl();

  return (
    <Tooltip
      title={formatMessage({
        id: 'logger.streamScreen.liveTopics.noTopicsForRange',
        defaultMessage: 'No se detectaron temas en este rango',
      })}
      placement="top"
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: TRACK_HEIGHT,
          zIndex: 2,
        }}
      >
        <HatchedStrip />
      </div>
    </Tooltip>
  );
}
